// 공개 사고사례 탐색기 — 비로그인 API (인증 불필요, 공유 api 클라이언트 사용)
import { api } from '../../lib/api'

export interface AcCase {
  id: string
  similarity: number | null
  summary: string
  hazard: string
  prevention: string
  category: string
  source_label: string
}

export interface AcSearchResult {
  query: string
  lang: string
  page: number
  page_size: number
  related_total: number
  related_label: string
  has_more: boolean
  cases: AcCase[]
  disclaimer: string
  cta: string
}

export interface AcAggBucket {
  label: string
  label_ko: string
  count: number
}

export interface AcAggregate {
  query: string
  lang: string
  sample_size: number
  by_accident_type: AcAggBucket[]
  by_cause: AcAggBucket[]
}

export async function acSearch(q: string, lang: string, page = 1): Promise<AcSearchResult> {
  const { data } = await api.get<AcSearchResult>('/ac-datacenter/search', {
    params: { q, lang, page },
  })
  return data
}

export async function acAggregate(q: string, lang: string): Promise<AcAggregate> {
  const { data } = await api.get<AcAggregate>('/ac-datacenter/aggregate', {
    params: { q, lang },
  })
  return data
}
